/**
 * Check if value is a valid guid
 * @param {string} value value
 */
export function isGuid(value) {
    return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(value);
}
//# sourceMappingURL=isGuid.js.map